import { render, staticRenderFns } from "./PresetSelectorDialog.vue?vue&type=template&id=2041736b&scoped=true&"
import script from "./PresetSelectorDialog.vue?vue&type=script&lang=ts&"
export * from "./PresetSelectorDialog.vue?vue&type=script&lang=ts&"
import style0 from "./PresetSelectorDialog.vue?vue&type=style&index=0&id=2041736b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2041736b",
  null
  
)

export default component.exports